'use client'

import {
  QuickRepliesBadge32,
  FastShipperBadge32,
  FrequentUploaderBadge32,
} from '@vinted/multichrome-icons'
import { Cell, Text, Icon } from '@vinted/web-ui'

import { SellerBadgeType } from '@marketplace-web/seller-engagement-tools/seller-engagement-tools-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { SellerBadgeTranslationKey } from '../../constants/badges'

type Props = {
  type: SellerBadgeType
}

const SellerBadge = ({ type }: Props) => {
  const translate = useTranslate('user.seller_badges')

  const SellerBadgeInfoByType = {
    [SellerBadgeType.ActiveLister]: {
      translationKey: SellerBadgeTranslationKey.FrequentUploads,
      icon: FrequentUploaderBadge32,
    },
    [SellerBadgeType.FastReplier]: {
      translationKey: SellerBadgeTranslationKey.QuickReplier,
      icon: QuickRepliesBadge32,
    },
    [SellerBadgeType.SpeedyShipper]: {
      translationKey: SellerBadgeTranslationKey.SpeedyShipping,
      icon: FastShipperBadge32,
    },
  }

  const { translationKey, icon } = SellerBadgeInfoByType[type]

  return (
    <div className="u-flexbox u-background-white">
      <Cell
        styling="tight"
        prefix={<Icon name={icon} aria={{ 'aria-hidden': 'true' }} />}
        title={translate(`${translationKey}.title`)}
        body={<Text text={translate(`${translationKey}.body`)} type="subtitle" as="span" />}
      />
    </div>
  )
}

export default SellerBadge
